import { render, staticRenderFns } from "./task-attachment-detail.vue?vue&type=template&id=33e63de4&"
import script from "./task-attachment-detail.vue?vue&type=script&lang=js&"
export * from "./task-attachment-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e63de4')) {
      api.createRecord('33e63de4', component.options)
    } else {
      api.reload('33e63de4', component.options)
    }
    module.hot.accept("./task-attachment-detail.vue?vue&type=template&id=33e63de4&", function () {
      api.rerender('33e63de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-attachment-detail.vue"
export default component.exports